import { Maybe } from "graphql/jsutils/Maybe";

import { LineTranscriptionSettingsFragment } from "@/graphql/generated/graphql";
import { Slice } from "../store.decl";

export type TranscriptionSettingsSliceState = {
  transcriptionSettings: Maybe<LineTranscriptionSettingsFragment>;
  setTranscriptionSettings: (
    transcriptionSettings: Maybe<LineTranscriptionSettingsFragment>
  ) => void;
};

export const createTranscriptionSettingsSlice: Slice<
  TranscriptionSettingsSliceState
> = (set) => ({
  transcriptionSettings: null,
  setTranscriptionSettings: (transcriptionSettings) => {
    set(() => ({
      transcriptionSettings,
    }));
  },
});
